import { isDanishMarket, isNorwegianMarket } from "../../countries";
import { eCategory } from "../absenceTypes-model";
import { eSalerySystem } from "../institution-model";
import {
  getDanishNonePlannedCodes,
  getDanishZeroDurationCategories,
} from "./danish";
import {
  getNorwegianNonePlannedCodes,
  getNorwegianZeroDurationCategories,
} from "./norwegian";

export function getZeroDurationCategories(): eCategory[] {
  if (isNorwegianMarket()) return getNorwegianZeroDurationCategories();
  if (isDanishMarket()) return getDanishZeroDurationCategories();
  return [];
}

export function getNonePlannedCodes(salarySystem: eSalerySystem): string[] {
  if (isNorwegianMarket()) return getNorwegianNonePlannedCodes();
  if (isDanishMarket()) return getDanishNonePlannedCodes(salarySystem);
  return [];
}
